// import projekt  from "../../assets/img/projekt_1.png";
import ReactPlayer from "react-player" 

const VDZ = ({ buttonClick }) => {
    return (
        <section className="projekt" id='vdz' style={{marginBottom:"0"}}>
            <div className="projekt__box">
                <div className="perex">
                    <span>Projekt</span>
                    <h2>Virtuální dopravní zóna</h2>
                    <p>Nehodu nanečisto najdete na všech akcích, kam jezdíme s našimi partnery a tvoříme dohromady Virtuální dopravní zónu.</p>
                </div>
                <div className="projekt__box__right">
                    <ReactPlayer url="https://www.youtube.com/watch?v=yP1t3Q3GKvk" controls width="70vw" height='40vw' />
                </div>
                
                <a
                    href="http://virtualnidopravnizona.cz/"
                    className="button transBlue"
                    target="_blank"
                    style={{ margin: "auto" }}
                >
                    více o virtuální dopravní zóně 
                </a>
            </div>
        </section>
    )
}

export default VDZ